export default {
  goToPlaylist: '',
  bannerDescription: '',
  live: '',
  daily: isDesktop => isDesktop,
  close: '',
  notShowAgainLabel: '',
};
